/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForgotPasswordResponse
 */
export interface ForgotPasswordResponse {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordResponse
     */
    message?: string;
}

export function ForgotPasswordResponseFromJSON(json: any): ForgotPasswordResponse {
    return ForgotPasswordResponseFromJSONTyped(json, false);
}

export function ForgotPasswordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForgotPasswordResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ForgotPasswordResponseToJSON(value?: ForgotPasswordResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

